// Contenido doctrinario y de políticas, extraído del libro "Capitalismo de Abundancia"
// Claudio Alejandro Nazar

export const PROVINCIAS_AR = [
  "Buenos Aires", "CABA", "Catamarca", "Chaco", "Chubut", "Córdoba",
  "Corrientes", "Entre Ríos", "Formosa", "Jujuy", "La Pampa", "La Rioja",
  "Mendoza", "Misiones", "Neuquén", "Río Negro", "Salta", "San Juan",
  "San Luis", "Santa Cruz", "Santa Fe", "Santiago del Estero",
  "Tierra del Fuego", "Tucumán",
];

export const DOCTRINA_PRINCIPIOS = [
  {
    n: "01",
    titulo: "La abundancia es una elección",
    bajada:
      "La escasez argentina no es natural. Es producida por una arquitectura institucional que se puede cambiar.",
  },
  {
    n: "02",
    titulo: "Patrimonio como base de la libertad",
    bajada:
      "La propiedad —empezando por la vivienda— es la infraestructura material de la libertad concreta.",
  },
  {
    n: "03",
    titulo: "La Nación como plataforma",
    bajada:
      "La Nación es la infraestructura histórica que hace posible la moneda, la ley, la defensa y el futuro.",
  },
  {
    n: "04",
    titulo: "Soberanía operativa",
    bajada:
      "Soberanía es la capacidad efectiva de decidir, financiar, ejecutar, proteger y sostener nuestras políticas.",
  },
  {
    n: "05",
    titulo: "Moneda como decisión política",
    bajada:
      "El dinero es una institución social. El PVA es soberanía con trazabilidad, no inflación ni dependencia.",
  },
  {
    n: "06",
    titulo: "Igualdad de punto de partida",
    bajada:
      "Cada argentino al cumplir 18 recibe su Capital Ciudadano. Igualdad de partida, no de llegada.",
  },
  {
    n: "07",
    titulo: "Industrialización de los recursos",
    bajada:
      "Litio, cobre, uranio, hidrocarburos, alimentos: se procesan en Argentina o pagan regalía completa.",
  },
  {
    n: "08",
    titulo: "Renta intergeneracional",
    bajada:
      "El FDRE acumula y rentabiliza la renta estratégica para las generaciones futuras. El capital no se toca.",
  },
  {
    n: "09",
    titulo: "Justicia rápida, corrupción imposible",
    bajada:
      "Plazos máximos de 2 años para sentencias. Extinción de dominio sobre el patrimonio ilícito.",
  },
  {
    n: "10",
    titulo: "Estado arquitecto",
    bajada:
      "Un Estado fuerte donde tiene que ser fuerte, limitado donde tiene que ser limitado, y eficaz siempre.",
  },
];

export const POLITICAS = [
  {
    id: "capital",
    titulo: "Capital Ciudadano",
    resumen: "Patrimonio base de 100.000 PVA al cumplir 18",
    detalle:
      "90.000 PVA (≈ USD 90.000) para vivienda + 10.000 PVA para equipamiento del hogar. Bonus de 25.000 PVA por unión convivencial. Componente turístico de 25.000 PVA por persona. Sin crédito, sin deudas, sin intereses.",
    metrica: "100.000 PVA base",
  },
  {
    id: "pva-bva",
    titulo: "PVA y BVA",
    resumen: "Moneda y billetera digital soberana",
    detalle:
      "El Peso Virtual Argentino (PVA) circula en la Billetera Virtual Argentina (BVA), una plataforma estatal vinculada al CUIL/CUIT con trazabilidad fiscal universal. Control monetario sin renunciar a la soberanía ni dolarizar.",
    metrica: "Trazabilidad 100%",
  },
  {
    id: "fdre",
    titulo: "FDRE — Fondo Soberano",
    resumen: "Capital intergeneracional con blindaje",
    detalle:
      "El Fondo de Desarrollo y Renta Estratégico transforma la renta de recursos naturales en capital permanente para las próximas generaciones. El principio es claro: el capital no se toca, solo se renta.",
    metrica: "Capital intocable",
  },
  {
    id: "fiscal",
    titulo: "0% Ganancias al salario",
    resumen: "Premio a la formalidad, fin del castigo al trabajo",
    detalle:
      "Eliminación total del Impuesto a las Ganancias sobre el salario. Deducción automática de gastos, reintegro de IVA y trazabilidad universal. IVA diferencial para el interior según tamaño de ciudad. Menos burocracia, más economía formal. El trabajo deja de ser castigado.",
    metrica: "Ganancias = 0",
  },
  {
    id: "justicia",
    titulo: "Justicia rápida y Estado fuerte",
    resumen: "Sentencias en menos de 24 meses, fin de la impunidad",
    detalle:
      "Justicia operativa con plazos máximos de 24 meses para sentencias, digitalización completa de expedientes, fin de la cosa juzgada cómplice y Estado arquitecto: fuerte para garantizar el orden, limitado para no abusar del ciudadano. Sin orden no hay abundancia.",
    metrica: "≤ 24 meses",
  },
  {
    id: "energia",
    titulo: "Energía soberana",
    resumen: "Vaca Muerta + nuclear + renovables",
    detalle:
      "Matriz energética diversificada con Vaca Muerta como plataforma industrial, YPF como instrumento estratégico, Plan Nuclear 2030 (2.000 ingenieros + 8.000 técnicos) y renovables donde son eficientes. Energía para industrializar.",
    metrica: "Plan Nuclear 2030",
  },
  {
    id: "industria",
    titulo: "Industrialización con valor agregado",
    resumen: "De granero a cocina del mundo",
    detalle:
      "Procesamiento obligatorio en territorio nacional con regalías diferenciales: castigamos la exportación bruta y premiamos la industrialización. Litio en batería argentina. Carne procesada argentina. Tecnología argentina.",
    metrica: "Regalía hasta 25%",
  },
  {
    id: "logistica",
    titulo: "Infraestructura y logística",
    resumen: "Ferrocarriles, marina mercante, puertos",
    detalle:
      "Fondo Logístico Estratégico (FLE) para ferrocarriles de carga, marina mercante nacional, puertos federales, cadenas de frío y corredores logísticos. La logística es la costura física de la Nación.",
    metrica: "FLE soberano",
  },
  {
    id: "pesca",
    titulo: "Revolución pesquera",
    resumen: "Proteína federal con barcaza BL-120",
    detalle:
      "IVA diferencial en toda la cadena, contribución del 5% al FLE, barcazas modulares BL-120 (100-120 toneladas), centros pesqueros interiores y trazabilidad ambiental. El pescado vuelve a ser comida federal.",
    metrica: "BL-120 modular",
  },
  {
    id: "turismo",
    titulo: "Turismo interno",
    resumen: "Arraigo, identidad y economías regionales",
    detalle:
      "25.000 PVA turísticos para que cada argentino conozca su país. Corredores turísticos federales, infraestructura local, empleo en cada región. El turismo interno es política de soberanía territorial.",
    metrica: "25.000 PVA turismo",
  },
];

export const CHAPTERS_SUMMARY = [
  { parte: "I", titulo: "El agotamiento argentino", desc: "Diagnóstico del deterioro en planos material, psicológico e histórico.", page: 15 },
  { parte: "II", titulo: "La doctrina del Capitalismo de Abundancia", desc: "Abundancia como elección, centralidad del patrimonio, Nación como plataforma.", page: 33 },
  { parte: "III", titulo: "Arquitectura monetaria y patrimonial", desc: "PVA, BVA, Capital Ciudadano, FDRE, FLE, fiscalidad y vivienda.", page: 49 },
  { parte: "IV", titulo: "Orden, justicia y Estado arquitecto", desc: "Justicia rápida, fin de la impunidad, Estado fuerte y limitado.", page: 77 },
  { parte: "V", titulo: "Fundamentos materiales de la soberanía", desc: "Litio, cobre, uranio, energía, infraestructura, pesca, industria, trabajo y turismo.", page: 95 },
  { parte: "VI", titulo: "Tecnología, poder nacional y destino", desc: "Autonomía tecnológica, Plan Nuclear, Plan Espacial y nuevo orden mundial.", page: 181 },
];

export const STATS = [
  { numero: "100.000", unidad: "PVA", desc: "Patrimonio base al cumplir 18" },
  { numero: "25%", unidad: "máx.", desc: "Regalía soberana de referencia" },
  { numero: "≤ 24", unidad: "meses", desc: "Plazo máximo para sentencias" },
  { numero: "0%", unidad: "salario", desc: "Ganancias eliminado al trabajo" },
];
